export function formatMinutes(minutes) {
  if (minutes == null) return '—';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m}м`;
  if (m === 0) return `${h}ч`;
  return `${h}ч ${m}м`;
}

export function feverEmoji(zone) {
  if (zone === 'red')    return '🔴';
  if (zone === 'yellow') return '🟡';
  if (zone === 'green')  return '🟢';
  return '';
}

export function formatPercent(n) {
  if (n == null) return '—';
  return `${Math.round(n)}%`;
}
